import { BossAuthTokenService } from './../../../services/boss-auth-token.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class IsLoggedInGuard implements CanActivate {
  constructor(
    private auth: Auth,
    private router: Router,
    private bossAuthTokenService: BossAuthTokenService,
  ) {}

  canActivate(): Observable<boolean> {
    const hasBossAuth = this.bossAuthTokenService.get();
    return new Observable((observer) => {
      onAuthStateChanged(this.auth, (user) => {
        if (user && hasBossAuth) {
          // console.log('User Logged In', this.bossAuthTokenService.get());
          localStorage.setItem('isLoggedIn', JSON.stringify(true));
          observer.next(true);
          observer.complete();
        } else {
          // console.log('User Logged In', this.bossAuthTokenService.get());
          localStorage.setItem('isLoggedIn', JSON.stringify(false));
          this.router.navigateByUrl('/auth/login');
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}
